import { User } from 'apis/types';

export const displayName = (user: Pick<User, 'username' | 'businessName'>): string => {
    return user.businessName || user.username || '';
};
